import { SxProps } from "@mui-wrapper";
import { CSSProperties } from "@mui/material";

/**
 * CSS needed to truncate text with an ellipsis with multiple rows if needed
 *
 * @param lines The number of lines to show before truncating.
 */
export function withEllipsisMultiline({
  lines,
}: {
  lines: number;
}): CSSProperties {
  return {
    overflow: "hidden",
    textOverflow: "ellipsis",
    // !: Do not use ...withEllipsis
    // because we don't need whiteSpace: "nowrap" in order to
    // break the line in two rows.
    wordBreak: "break-word",
    lineHeight: "24px",
    // These properties allow to show an ellipsis on two lines
    // Unfortunately it is only allowed in webkit because there's
    // no native support from CSS for this, only for one line.
    display: "-webkit-box",
    WebkitLineClamp: lines,
    WebkitBoxOrient: "vertical",
  };
}

/** Style override for action buttons in information tab */
export const ActionButtonSx: SxProps = {
  width: "250px",
  height: "40px",
};
